/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_SyncedInputs */

const en_issue_not_synced = /** @type {(inputs: Issue_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not in Business Central yet`)
};

/**
* | output |
* | --- |
* | "is not in Business Central yet" |
*
* @param {Issue_Not_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_synced = /** @type {((inputs?: Issue_Not_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_synced(inputs)
});